/* eslint-disable react/no-array-index-key */
import { DATE_FORMAT_WITH_TIME } from 'constants/defaultConstants';
import { format } from 'date-fns';
import { useTranslate } from 'hooks/useTranslate';
import EmptyStateForTable from 'modules/_shared/components/EmptyStates/EmptyStateForTable';
import { FC } from 'react';
import { Observation } from 'types';

type PartnerObservationsSectionProps = {
  observations: Observation[];
};

const PartnerObservationsSection: FC<PartnerObservationsSectionProps> = ({
  observations,
}) => {
  const { t } = useTranslate();

  return (
    <section className="partner-investment-wrapper mb-5">
      <div className="nk-block-head">
        <div className="nk-block-between d-flex flex-column flex-md-row">
          <div className="nk-block-head-content">
            <h4 className="nk-block-title">{t('Observations')}</h4>
            <div className="nk-block-des">
              <p>{t('ObservationsPartnerTabDescription')}</p>
            </div>
          </div>

          <div className="nk-block-head-content">
            <div className="nk-block float-right">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {}}
                disabled
              >
                <em className="icon ni ni-plus mr-1" />
                {t('AddObservation')}
              </button>
            </div>
          </div>
        </div>

        <div className="card card-bordered card-preview mt-4">
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col" className="w-200px">
                  {t('Date')}
                </th>
                <th scope="col">{t('Status')}</th>
                <th scope="col">{t('Observation')}</th>
              </tr>
            </thead>

            {observations?.length > 0 ? (
              <tbody>
                {observations?.map((item: Observation, index: number) => (
                  <tr key={`note-row-${index}`}>
                    <td className="w-200px">
                      {format(new Date(item.date), DATE_FORMAT_WITH_TIME)}
                    </td>
                    <td>{item.status}</td>
                    <td>{item.text}</td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <EmptyStateForTable
                colspan={3}
                mainMessage={t('NoObservations')}
                infoMessage=""
              />
            )}
          </table>
        </div>
      </div>
    </section>
  );
};

export default PartnerObservationsSection;
